<div class="flex grow flex-col gap-0.5">
  <span class="font-bold text-default">
    {{ 'Please verify your account in order to receive notifications' | translate }}
  </span>
  <span
    class="text-support"
    [innerHtml]="
      'An email was sent to [email], you can resend it using the button on the right. Easy peasy!'
        | translate: { email: email() | bold }
    "
  ></span>
</div>

<div class="flex items-center justify-start gap-2.5" [class]="{ 'mr-16': isChatActive() }">
  <a sb-button [color]="'primary'" [routerLink]="['my-account', 'login']">
    {{ 'Change mail' | translate }}
  </a>
  <button sb-button [color]="'secondary'" (click)="resendEmail()">
    {{ 'Resend mail' | translate }}
  </button>

  <button sb-icon-button [color]="'transparent'" [attr.aria-label]="'Close' | translate" (click)="onClose()">
    <sb-icon [name]="'close-regular'" />
  </button>
</div>
